import React, { useEffect, useState } from "react";
import Select from "../../Components/Select";
import Checkbox from "../../Components/Checkbox";
import Input from "../../Components/Input";
import Mortgage from "./Mortgage";

const Borrower = ({ userQuery, setUserQuery, errors }) => {
  const [checkbox, setCheckbox] = useState(false);
  const [bankruptcyType, setBankruptcyType] = useState("");
  const [docType, setDocType] = useState("");

  //Options for Citizenship dropdown

  const optioncity = [
    { value: "US citizen", label: "US Citizen" },
    { value: "Permanent Resident", label: "Permanent Resident Alien" },
    { value: "EAD/VISA Eligible", label: "EAD/VISA Eligible" },
    { value: "ITIN", label: "ITIN" },
    { value: "Foreign National", label: "Foreign National" },
  ];

  // Options for Documentation Type dropdown

  const optionsDoc = [
    { value: "Lite Doc", label: "Lite Doc" },
    { value: "12M Personal Bank Stmts", label: "12M Personal Bank Stmts" },
    { value: "12M Business Bank Stmts", label: "12M Business Bank Stmts" },
    { value: "Asset Utilization", label: "Asset Utilization" },
    { value: "DSCR", label: "DSCR" },
  ];

  // Data for Bankruptcy type Radio buttons

  const optionstype = [
    { value: "None", label: "None" },
    { value: "Chapter 7", label: "Chapter 7" },
    { value: "Chapter 11", label: "Chapter 11" },
    { value: "Chapter 12", label: "Chapter 12" },
    { value: "Chapter 13", label: "Chapter 13" },
  ];

  const handleBankruptcyTypeChange = (value) => {
    setBankruptcyType(value);
  };

  const handleDocType = (value) => {
    setDocType(value);
  };

  useEffect(() => {
    console.log("bankruptcyType", bankruptcyType);
  }, []);

  const handleInputChange = (field, value) => {
    setUserQuery({ ...userQuery, [field]: value });
  };

  return (
    <div className="text-[#333] w-full bg-white p-12 rounded-xl">
      {/* Heading */}

      <div className="flex items-center">
        <h1 className=" px-4 py-1 text-[#333]   text-lg  font-semibold	">
          Borrower Information
        </h1>
        <h3 className="  text-[#037dfa]  text-xs font-medium   cursor-pointer  ">
          Learn More
        </h3>
      </div>

      {/* Check-boxes (Citizenship, Self Employed, First Time Home Buyer, Includes LLC) */}

      <div className="   p-4 ">
        <div className="flex items-end">
          <div className="w-1/2 pr-6">
            <Select
              label={"Citizenship"}
              options={optioncity}
              value={userQuery.citizenship}
              handlechange={(e) => handleInputChange("citizenship", e.target.value)}
            />
          </div>

          <div className="w-1/2 pr-6">
            <Checkbox
              label={"Self Employed"}
              userQuery={userQuery}
              setUserQuery={setUserQuery}
            />
          </div>
        </div>
        <div className="flex items-end">
          <div className="w-1/2 pr-6">
            <Checkbox
              label={"First Time Home Buyer"}
              userQuery={userQuery}
              setUserQuery={setUserQuery}
            />
          </div>

          <div className="w-1/2 pr-6 ">
            <Checkbox
              label={"Includes LLC"}
              userQuery={userQuery}
              setUserQuery={setUserQuery}
            />
          </div>
        </div>

        <div className=" bg-[#F6F8FB] p-12 my-12 rounded-lg ">
          {/* Documentation Type */}
          <div className="flex space-x-12 mb-6">
            <div className="w-full">
              <p className="font-semibold text-sm">Documentation Type</p>
              <Select
                options={optionsDoc}
                value={userQuery.doc_type}
                handlechange={(e) =>
                  handleInputChange("doc_type", e.target.value)
                }
              />
            </div>

            {/* Debt-to-Income Ratio */}
            {userQuery.doc_type !== "DSCR" && (
              <div
                className={`w-full ${userQuery.doc_type !== "DSCR" ? "" : ""}`}
              >
                <p className="font-semibold text-sm">Debt to Income Ratio</p>
                <Input
                  value={userQuery.dti_ratio}
                  handlechange={(e) =>
                    handleInputChange("dti_ratio", e.target.value)
                  }
                  Placeholder={"0.0"}
                  type={"number"}
                />
                {errors && (
                  <p className=" text-[#ff6839] font-Poppins text-sm px-3 mt-1  ">
                    {errors.dti_ratio}
                  </p>
                )}
              </div>
            )}
          </div>
          {/*  When DSCR Option Inputs will be Replaced */}

          {userQuery.doc_type === "DSCR" && (
            <div className="flex space-x-12">
              <div className="w-full">
                <p className="font-semibold">Debt Service Coverage Ratio</p>
                <Input
                  value={userQuery.dscr}
                  handlechange={(e) =>
                    handleInputChange("dscr", e.target.value)
                  }
                  type={"number"}
                />
              </div>
              <div className="w-full">
                <p className="font-semibold">Subject Property Gross Rent</p>
                <Input type={"number"} />
              </div>
            </div>
          )}
        </div>
        <div className="flex space-x-12 mb-6">
          {/* Representative Credit Score*/}

          <div className="w-full">
            <Input
              Label={"Representative Credit Score"}
              value={userQuery.credit_score}
              handlechange={(e) =>
                handleInputChange("credit_score", e.target.value)
              }
              Placeholder={"700"}
              type={"number"}
            />
            {errors && (
              <p className=" text-[#ff6839] font-Poppins text-sm px-3 mt-1   ">
                {errors.credit_score}
              </p>
            )}
          </div>
          {/* Foreclosure */}

          <Input Label={"Foreclosure"} type={"number"} />
        </div>
        {/* Mortgage Lates */}
        <div className="mb-6">
          <p className="text-sm font-semibold mb-[11px]">Mortgage Lates</p>
          <div className="flex w-full  space-x-4 2xl:space-x-8  ">
            <div className="w-full  ">
              <Mortgage
                label={"x30"}
                userQuery={userQuery}
                setUserQuery={setUserQuery}
              />
            </div>
            <div className="w-full">
              <Mortgage
                label={"x60"}
                userQuery={userQuery}
                setUserQuery={setUserQuery}
              />
            </div>
            <div className="w-full">
              <Mortgage
                label={"x90"}
                userQuery={userQuery}
                setUserQuery={setUserQuery}
              />
            </div>
            <div className="w-full  ">
              <Mortgage
                label={"x120"}
                userQuery={userQuery}
                setUserQuery={setUserQuery}
              />
            </div>
          </div>
        </div>

        <div className="flex space-x-12">
          {/* Short Sale */}

          <div className="w-full">
            <Input
              Label={"Short Sale"}
              type = {"number"}
            />
          </div>

          <div className="w-full">
            {/* Bankruptcy type CHECK-BOXES */}

            <Select
              label={"Bankruptcy type"}
              options={optionstype}
              value={bankruptcyType}
              onChange={handleBankruptcyTypeChange}
              userQuery={userQuery}
              setUserQuery={setUserQuery}
            />

            {/* When user clicks on any of checkbox Content will appear according to relevant checkbox */}

            {["Chapter 7", "Chapter 11", "Chapter 12", "Chapter 13"].includes(
              bankruptcyType
            ) && (
              <>
                <Input Label="bankruptcy Filing" />
                <Input Label="Bankruptcy Dismissal" />
                <Input Label="Bankruptcy Discharge" />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Borrower;
